import { UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import * as _ from 'lodash';
import { Directive } from '@angular/core';

@Directive()
export abstract class EaSimulationAvPackFormBuilder extends PrFormAbstract {
  options: any = {};

  generate(entity: any, options?) {
    this.options = options;
    let allocation: UntypedFormGroup[] = [];
    if (entity)
      _.forEach(entity, (scpi, i) =>
        allocation.push(this.formBuilder.group(this.createModel(scpi, i))),
      );

    let group = this.formBuilder.group({
      allocation: this.formBuilder.array(allocation, Validators.nullValidator),
    });

    this.form = group;

    return group;
  }

  public createModel(item, i?) {
    let model = {
      id: item ? item.id : null,
      isin: item ? item.isin || item.supportIsin : null,
      index: item && item.index ? item.index : !_.isNil(i) ? i : null,
      omniprodId: item ? item.omniProductId || item.omniprodId : null,
      name: item ? item.name : null,
      allocationPercentage: item ? item.allocationPercentage : null,
      favorite: item ? item.favorite : null,
      type: item ? item.type : null,
      supportDescription: this.options ? this.options.supportDescription : null,
      totalInvestedAmount: this.options ? this.options.initialDeposit : null,
    };
    return model;
  }

  extract() {
    let dto: any = this.emptyIsNull(this.form.value.allocation);
    return dto;
  }
}
